<template>
  <el-select :disabled="disabled" filterable :clearable='clearable' @change="handleChange" :value="data.value" placeholder="请选择"
             @clear="handleChange">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in getProvList" :key="index"></el-option>
  </el-select>
</template>

<script>
    import {province} from '@/services/operation'

    export default {
        name: 'Province',
        props: {
            value: {},
            disabled: {
                type: Boolean,
                default: false
            },
            clearable:{
                type: Boolean,
                default: true
            }
        },

        data() {
            return {data: {}, getProvList: []}
        },
        watch: {
            value:{
                immediate:true,
                handler(value){
                    if (value) {
                            this.data = value;
                        } else {
                            this.data = {};
                        }

                }
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            setSelectValue(value) {
                this.data = {
                    value: value,
                    name: ""
                }
            },
            handleChange(value) {
                
                let find = this.getProvList.find((item, i) => {
                    return item.value == value
                })
                if (!find) {
                    find = {};
                }
               
                if (find==undefined) {
                    find = "";
                }
                this.$emit("input", {...find});
                this.$emit("change", {...find});
                this.data = {...find};
            },
            async loadData() {
                const response = await province({});
                if (response) {
                    this.getProvList = response.data.map((item, i) => {
                        return {name: item.name, value: item.id}
                    })
                }
            }

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AddressSelect/Province.vue